import { useToast } from "../../hooks/useToast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./Toast"
import { CheckCircledIcon, CrossCircledIcon, ExclamationTriangleIcon } from "@radix-ui/react-icons"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, type, ...props }) {
        const Icon = type === 'error' ? CrossCircledIcon : 
                    type === 'success' ? CheckCircledIcon : 
                    ExclamationTriangleIcon

        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && (
                <ToastTitle className="flex items-center gap-2">
                  <Icon className={`h-4 w-4 ${type === 'error' ? 'text-destructive' : type === 'success' ? 'text-green-500' : 'text-yellow-500'}`} />
                  {title}
                </ToastTitle>
              )}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
} 